import React, { Component } from "react"; 
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../components/CustomComponent.js";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    loading(false);
    // window.print();
  }
  Get = async (page) => {
    loading(true);
    let body = {};
    let result = await GET("transaction", body);
    if (result?.status) {
      this.setState({ data: result.data, count: result.count });
    }
    loading(false);
  };
  render() {
    return (
      <div className="mx-auto bg-white p-3 pdf" style={{ width: 1116, height: 1579 }}>
        <table className="table rounded-3 overflow-hidden table-bordered mb-0">
          <tr>
            <td rowSpan={2}>
              <div className="d-flex align-items-center">
                {/* <img src={LOGO} style={{ width: 80, height: 80, objectFit: "contain", marginRight: 6 }} alt="LOGO" className="bg-contain" /> */}
                <div className="px-2">
                  <h5 className="fw-bold">นิติบุคคลอาคารบ้านชุดบ้านเอื้ออาทรวัดกู้3</h5>
                  <div>
                    เลขที่ 159 อาคาร 59 หมู่ 3 ต.บางพูด อ.ปากเกร็ด จ.นนทบุรี 11120
                    <br />
                    เบอร์โทร 021483506 เลขที่ผู้เสียภาษี 0994001028397
                  </div>
                </div>
              </div>
            </td>
            <td className="wpx-230 text-center">
              <h4 className="fw-bold mb-0">ใบเสร็จรับเงิน</h4>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                เลขที่ : IW030067070001
                <br />
                วันที่ : 10 กรกฎาคม 2567
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                ได้รับเงินจาก : คุณบงกช พิณภาคย์
                <br />
                ที่อยู่ : 153/00 หมู่ 3 ต.บางพูด อ.ปากเกร็ด จ.นนทบุรี 11120
              </div>
            </td>
            <td>
              <div>
                ชำระโดย : เงินสด
                <br />
                วันที่ : 10/07/2567 เวลา 15:24 น.
              </div>
            </td>
          </tr>
        </table>
        <table className="table rounded-3 overflow-hidden table-bordered mb-0">
          <tr>
            <td className="text-center wpx-50">ลำดับ</td>
            <td>รายการ</td>
            <td className="wpx-140">
              <div>
                เลขมาครจดครั้งนี้
                <br />
                วันที่ 28/09/2567
              </div>
            </td>
            <td className="wpx-160">
              <div>
                เลขมาครจดครั้งก่อน
                <br />
                วันที่ 28/08/2567
              </div>
            </td>
            <td className="text-center wpx-120">จำนวนหน่วยที่ใช้</td>
            <td className="text-center wpx-120">รวมเป็นเงิน</td>
          </tr>
          <tr>
            <td className="text-center py-2">1</td>
            <td>ค่าน้ำประปา ประจำเดือน กันยายน 2567</td>
            <td className="text-end">0</td>
            <td className="text-end">0</td>
            <td className="text-end">0</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-center py-2">2</td>
            <td colSpan={4}>ค่าบริการรักษาอุปกรณ์น้ำ</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-center py-2">3</td>
            <td colSpan={4}>ค่าบริการจัดเก็บขยะ</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-center py-2">4</td>
            <td colSpan={4}>ค่าใช้จ่ายส่วนกลาง ประจำเดือน ตุลาคม 2567</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-center py-2">5</td>
            <td colSpan={4}>อื่นๆ</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-center py-2">6</td>
            <td colSpan={4}>ค่าน้ำประปา ประจำเดือน กันยายน 2567</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-center py-2">7</td>
            <td colSpan={4}>ค่าน้ำประปา ประจำเดือน กันยายน 2567</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td colSpan={2} rowSpan={3}>
              <div className="w-100 d-flex position-relative">
                จำนวนเงิน (ตัวอักษร)
                <div className="position-absolute" style={{ right: 0, bottom: 4 }}>
                  .................................................................................................................................................
                </div>
              </div>
              <div>หมายเหตุ</div>
              <div>(โปรดเก็บใบเสร็จไว้)</div>
            </td>
            <td colSpan={2} rowSpan={3} className="text-center">
              <br />
              <br />
              <div>ลงชื่อ......................................................................ผู้รับเงิน</div>
              <div>(นางสาวอุมารินทร์ สอนคุ้ม)</div>
              <div>ธุรการ/การเงิน</div>
            </td>
            <td className="text-end">รวมเป็นเงิน</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-end">ปรับปรุงยอดเงิน</td>
            <td className="text-end">65.00</td>
          </tr>
          <tr>
            <td className="text-end">รวมเป็นเงินทั้งสิ้น</td>
            <td className="text-end">65.00</td>
          </tr>
        </table>
      </div>
    );
  }
}
